import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { languagesStateSelector } from '~/selectors';

import { Language } from './types';

export const useLanguages = (): {
  languages: Language[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
  getLanguageByCode: (languageCode: string) => Language | undefined;
} => {
  const selectorData = useSelector((state: StoreState) => {
    return languagesStateSelector(state);
  });
  const { languages } = selectorData;

  const getLanguageByCode = useCallback(
    (languageCode: string) => {
      return languages.find((lang) => lang.fComLanguageCode === languageCode);
    },
    [languages],
  );

  return {
    ...selectorData,
    getLanguageByCode,
  };
};
